var map = {
	"./active-check-ico.svg": "283b",
	"./arrow.svg": "315f",
	"./basket.svg": "1c23",
	"./black-arrow-down.svg": "68cb",
	"./canopy-arched.svg": "15f5",
	"./canopy-gable.svg": "3ba1",
	"./canopy-single.svg": "3202",
	"./check-all-black.svg": "4731",
	"./check-all.svg": "7f92",
	"./checkbox.svg": "1748",
	"./coin.svg": "b745",
	"./delete.svg": "4edd",
	"./delivery-np.svg": "6fd0",
	"./diamond.svg": "cead",
	"./down_arrow.svg": "0117",
	"./down_arrow_black.svg": "5faf",
	"./download-3d.svg": "d98e",
	"./download-white.svg": "039c",
	"./download.svg": "22b4",
	"./duble-arrow.svg": "04cb",
	"./green-check.svg": "3deb",
	"./hero-check-red.svg": "00fa",
	"./hero-check.svg": "dac9",
	"./ico-error.svg": "9bfa",
	"./ico-success.svg": "58d9",
	"./left-arrow.svg": "3457",
	"./location.svg": "c391",
	"./money.svg": "c657",
	"./notification.svg": "420c",
	"./payment-card.svg": "83af",
	"./payment-mono.svg": "c798",
	"./pdf.svg": "3e10",
	"./pdf1.svg": "aaa8",
	"./pen.svg": "13bc",
	"./play.svg": "09dc",
	"./premium.svg": "889e",
	"./right-arrow.svg": "689d",
	"./save.svg": "107a",
	"./share.svg": "40eb",
	"./smallArrow.svg": "c5d6",
	"./uncompared.svg": "66bc",
	"./unfavorite.svg": "9cbe",
	"./user-ico.svg": "b543"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f350";